// Core
import { Box, Text, Image, Center, Flex, useColorMode } from '@chakra-ui/react';
import { NavLink } from 'react-router-dom';

// Assets
import { ReactComponent as ClearArrowIcon } from 'assets/svg/clear-arrow.svg';
import logo from 'assets/img/logo.png';
import Success from 'assets/img/one-time-payments/success.png';

const OneTimePaymentSuccess = () => {
  const { colorMode } = useColorMode();
  const isDark = colorMode === 'dark';

  return (
    <Box className="one-time-payment-container">
      <Center>
        <Image src={logo} w="180px" h="42px" />
      </Center>
      <Text
        fontStyle="italic"
        fontSize={{ base: '32px', sm: '56px' }}
        textTransform="uppercase"
        textAlign="center"
        mt="7vh"
        variant="header-gradient"
        fontWeight="900"
      >
        One-time payment <br /> was successful
      </Text>
      <Center>
        <Image src={Success} mt="-6vh" />
        { isDark && <Box
          bg="rgba(64, 155, 255, 0.82)"
          zIndex="0"
          filter="blur(80px)"
          borderRadius="100%"
          w="200px"
          top="27.5vh"
          h="200px"
          position="absolute"
          left="50%"
          transform="translate(-50%, 0px)"
        /> }
      </Center>
      <Center>
        <NavLink to="/">
          <Flex gap="5px">
            <ClearArrowIcon fontSize="24" />
            <Text
              fontWeight="400"
              fontSize="16px"
              variant="header-gradient"
              fontStyle="normal"
              textTransform="none"
            >
              Return to LMCT+ website
            </Text>
          </Flex>
        </NavLink>
      </Center>
    </Box>
  );
};

export default OneTimePaymentSuccess;
